import React, { useState, useEffect } from "react";
import {
  Edit2,
  Trash2,
  Search,
  ChevronLeft,
  ChevronRight,
  RefreshCw,
} from "lucide-react";
import "./ProductDetails.css";
import axios from "axios";
import { toast } from "react-toastify";

const Category = () => {
  const initialFormState = {
    name: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isEditing, setIsEditing] = useState(false);

  const API_URL = "https://payyug.in/api";
  const superAdminId = localStorage.getItem("adminuserId");

  // 1. FETCH DATA (Added dependency in useEffect below)
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/product-loan/category/list`, {
        params: {
          superAdminId,
          page: currentPage,
          limit: itemsPerPage,
        },
      });
      if (res.data.success) {
        setCategories(res.data.data || []);
        setTotalPages(res.data.pages || 1);
        setTotalRecords(res.data.total || 0);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      toast.error(err?.response?.data?.message||"Failed to load records");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Trigger fetch on mount and pagination change
  useEffect(() => {
    if (superAdminId) {
      fetchCategories();
    }
  }, [currentPage, itemsPerPage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFormData(initialFormState);
    setIsEditing(false);
  };

  // 2. CREATE & UPDATE
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...formData, superAdminId, branchId: 1 };
    try {
      if (isEditing) {
        const res = await axios.put(
          `${API_URL}/product-loan/category/update/${formData.id}`,
          payload
        );
        if (res.data.success) toast.success(res.data.message||"Category Updated Successfully!");
      } else {
        const res = await axios.post(
          `${API_URL}/product-loan/category/create`,
          payload
        );
        if (res.data.success) toast.success(res.data.message||"New Category Created!");
      }
      handleReset();
      fetchCategories();
    } catch (err) {
      toast.error(err.response?.data?.message || "Operation failed");
    }
  };

  // 3. DELETE
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        const res = await axios.delete(`${API_URL}/product-loan/category/delete/${id}`);
        if (res.data.success) {
          toast.success(res.data.message||"Category Deleted!");
          fetchCategories();
        }
      } catch (err) {
        toast.error(err?.response?.data?.message||"Delete failed");
      }
    }
  };

  // ✅ FIXED SEARCH LOGIC: Matching categoryName
  const filteredItems = categories.filter((cate) =>
    (cate.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };
  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleLimitChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="product-master-container">
      <div className="product-master-header-card">
        <h2>{isEditing ? "Edit Category" : "Create New Category"}</h2>
        <button className="reset-btn" onClick={handleReset}>
          <RefreshCw size={14} /> Reset
        </button>
      </div>

      <div className="product-master-form-card">
        <form onSubmit={handleSubmit}>
          <div className="product-master-form-grid">
            <div className="product-master-form-input-group">
              <label>Category Name</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter Category Name"
                style={{ maxWidth: "300px" }}
              />
            </div>
          </div>
          <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
            <button type="submit" className="product-master-form-isubmin-btn">
              {isEditing ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>

      <div className="product-master-table-container">
        <div className="product-master-table-controles">
          <div>
            Show{" "}
            <select value={itemsPerPage} onChange={handleLimitChange}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>{" "}
            entries
          </div>
          <div className="product-master-table-search-box" style={{ position: "relative" }}>
            <Search
              size={16}
              style={{
                position: "absolute",
                left: "10px",
                top: "10px",
                color: "#999",
              }}
            />
            <input
              placeholder="Search categories..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ paddingLeft: "35px" }}
            />
          </div>
        </div>
<div className="product-master-report">
        <table className="product-master-table-report">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Category Name</th>
              <th style={{ textAlign: "center" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>Loading Records...</td>
              </tr>
            ) : filteredItems.length > 0 ? (
              filteredItems.map((v, index) => (
                <tr key={v.id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  {/* ✅ Corrected field name */}
                  <td>{v.name || "N/A"}</td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      className="btn-edit"
                      onClick={() => {
                        setFormData(v);
                        setIsEditing(true);
                      }}
                    >
                      <Edit2 size={16} />
                    </button>
                    <button className="btn-delete" onClick={() => handleDelete(v.id)}>
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>No records found</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>

        <div className="product-master-pagination">
          <div className="pagination-info">
            Page <strong>{currentPage}</strong> of {totalPages} ({totalRecords} items)
          </div>
          <div className="pagination-buttons">
            <button
              className="product-loan-scheme-pagination-btn"
              disabled={currentPage === 1 || loading}
              onClick={handlePrev}
            >
              <ChevronLeft size={14} /> Previous
            </button>
            <button
              className="product-loan-scheme-pagination-btn"
              disabled={currentPage >= totalPages || loading}
              onClick={handleNext}
            >
              Next <ChevronRight size={14} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;